import {Pipe, PipeTransform} from '@angular/core';

const PURPLE = '#7B2FBE';
const SIZE = 40;

@Pipe({
    name: 'customMarker'
})
export class CustomMarkerPipe implements PipeTransform {

    transform(_value?: any): HTMLElement {
        // AdvancedMarkerElement anchors the element's bottom-center to the lat/lng position.
        // To place the circle CENTER at the cursor, we use a zero-size container as anchor
        // and absolutely position the SVG so its visual center aligns with the container's origin.
        const container = document.createElement('div');
        container.style.cssText = `pointer-events:none;position:relative;width:0;height:0;`;

        const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        svg.setAttribute('viewBox', '0 0 100 100');
        // left: -SIZE/2 centers horizontally; translateY(50%) shifts the SVG down by half its
        // height so the SVG center (circle center) lands exactly at the container origin (anchor).
        svg.style.cssText = `position:absolute;left:${-SIZE / 2}px;bottom:0;transform:translateY(50%);pointer-events:none;width:${SIZE}px;height:${SIZE}px;`;

        const circle = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
        circle.setAttribute('cx', '50');
        circle.setAttribute('cy', '50');
        circle.setAttribute('r', '45');
        circle.setAttribute('fill', PURPLE);
        circle.setAttribute('stroke', 'white');
        circle.setAttribute('stroke-width', '5');

        const text = document.createElementNS('http://www.w3.org/2000/svg', 'text');
        text.setAttribute('x', '50');
        text.setAttribute('y', '72');
        text.setAttribute('font-family', 'Arial,sans-serif');
        text.setAttribute('font-size', '65');
        text.setAttribute('font-weight', 'bold');
        text.setAttribute('text-anchor', 'middle');
        text.setAttribute('fill', 'white');
        text.textContent = '!';

        svg.appendChild(circle);
        svg.appendChild(text);
        container.appendChild(svg);

        return container;
    }

}
